var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"preview-pdf mx-auto mt-5 mb-3"},[_c('vue-pdf-embed',{attrs:{"source":_vm.pdfUrl,"text-layer":false}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }